import 'Styles/layout/theme.scss';
import '@js/customElements/LocalizationForm';
import '@js/customElements/NsfwOverlay';
import '../../marketing/newsletter';
import '../../search/search';
import GeoIP from '../../geolocation/geoip';
import SolarisCart from '../../checkout/cart/SolarisCart';

function scrollFunction() {
  const topbar = document.querySelector('.header-toolbar');
  const cart = document.querySelector('.sticky-navbar__cart');

  if (document.body.scrollTop > topbar.offsetHeight || document.documentElement.scrollTop > topbar.offsetHeight) {
    cart.style.display = 'flex';
  } else {
    cart.style.display = 'none';
  }
}

window.onscroll = () => scrollFunction();

document.addEventListener('DOMContentLoaded', () => {
  window.SolarisCart = new SolarisCart();

  GeoIP.get().then(({ currency_code: currencyCode }) => {
    window.Currency.customSetCurrency(currencyCode);
  });
});
